import { isString } from "lodash"
import request from "."
import { CommonListParams } from "../types/common"
import { QuotationRequestItem } from "@/types/quotationRequestItem"
import { QuotationRequest } from "@/types/requirement";

export type CategoryUpdateKey = 'name' | 'desc' | 'hsCode';
// 0：不取整；1：向下取整；2：向上取整；3：四舍五入。
export type QuotationPurchaseRound = 0 | 1 | 2 | 3;

const url = 'wms/quotationRequest'

const apis = {
  quotationRequestList: `${url}/list`,
  quotationRequestDetail: (id: string) => `${url}/${id}/fetch`,
  refuse: (id: string) => `${url}/${id}/refuse`,
  submit: (id: string) => `${url}/${id}/submit`,
  read: (id: string) => `${url}/${id}/read`,
  quotationPurchase: (round?: QuotationPurchaseRound) => round === undefined
    ? `${url}/purchase/generate`
    : `${url}/purchase/${round}/generate`,

  lazyQuotate: (id: string) => `${url}/${id}/deadline/update`,
  quotationRequestUpdate: (id: string) => `${url}/${id}/update`,
}

const quotationRequestList = (params?: CommonListParams) => {
  if (params && params.body && !isString(params.body)) {
    return Promise.reject(10012)
  }
  return request<Array<QuotationRequestItem>, string>(apis.quotationRequestList, { params })
    .then(({ body }) => Promise.resolve({ body }))
    .catch(err => Promise.reject(err))
}

export const quotationRequestDetail = (id: string) => {
  if (id && !isString(id)) {
    return Promise.reject(10012)
  }
  return request<QuotationRequestItem, void>(apis.quotationRequestDetail(id))
    .then(({ body }) => Promise.resolve(body))
    .catch(err => Promise.reject(err))
}

const quotationRequestRefuse = (id: string) => {
  if (id && !isString(id)) {
    return Promise.reject(10012)
  }
  return request<QuotationRequestItem, void>(apis.refuse(id))
    .then(() => Promise.resolve())
    .catch(err => Promise.reject(err))
}

interface QuotationRequestSubmit {
  supplierPrice: number;
  supplierTime: number;
  mpq: number | null;
  days: number;
  remark?: string;
  spareCount: string;
  spareRate: string;
}
export const quotationRequestSubmit = (id: string, props: QuotationRequestSubmit) => {
  if (id && !isString(id)) {
    return Promise.reject(10012)
  }
  return request<void, QuotationRequestSubmit>(apis.submit(id), { params: { body: props } })
    .then(({ body }) => {
      return Promise.resolve(body)
    })
    .catch(err => Promise.reject(err))
}

const quotationRequestRead = (id: string) => {
  if (id && !isString(id)) {
    return Promise.reject(10012)
  }
  return request<void, QuotationRequestSubmit>(apis.read(id))
    .then(() => Promise.resolve())
    .catch(err => Promise.reject(err))
}

export const quotationPurchase = (body: Array<string>, orgId?: string, round?: QuotationPurchaseRound) => {
  return request<QuotationRequest[], Array<string>>(apis.quotationPurchase(round), {
    params: { body },
    // requestConfig: {
    //   headers: { org_id: orgId }
    // }
  })
    .then((res) => Promise.resolve(res.body))
    .catch(err => Promise.reject(err))
}

const lazyQuotateApi = (id: string, ddl: number) => {
  if (id && !isString(id)) {
    return Promise.reject(10012)
  }
  return new Promise<QuotationRequest>((resolve, reject) => {
    request<QuotationRequest, number>(apis.lazyQuotate(id), { params: { body: ddl } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
}

interface QuotationRequestUpdate {
  mrd?: number;
  deadline?: number;
  standardPrice?: string;
  standardCurrency?: string;
  exchangeRate?: string;
}
export const quotationRequestUpdate = (id: string, qr: QuotationRequestUpdate) => {
  if (id && !isString(id)) {
    return Promise.reject(10012)
  }
  return new Promise<QuotationRequest>((resolve, reject) => {
    request<QuotationRequest, QuotationRequestUpdate>(apis.quotationRequestUpdate(id), { params: { body: qr } })
      .then((res) => resolve(res.body))
      .catch((err) => reject(err));
  })
}

const exportObject = {
  quotationRequestList,
  quotationRequestDetail,
  quotationRequestSubmit,
  quotationRequestRefuse,
  quotationRequestRead,
  quotationPurchase,
  lazyQuotateApi,
  quotationRequestUpdate,
}

export type { QuotationRequestSubmit }
export default exportObject
